<div class="wrapper">
  <button mat-icon-button mat-dialog-close="true" class="closing-button">
    <mat-icon>close</mat-icon>
  </button>
  <h2 mat-dialog-title>{{ title }}</h2>
  <mat-dialog-content>{{ content }}</mat-dialog-content>
</div>
